import DashLayout from "@/layouts/DashLayout";
import PageTitle from "@/components/PageTitle";
import InfoUser from "@/components/profile/tabs/InfoUser";
import EditableAvatar from "@/components/EditableAvatar";
import { useUpdateProfilImage } from "@/hooks/parametres/useEditProfil";
import { formatRoles } from "@/lib/utils";
import { Roles } from "@/redux/services/user/user.type";

const roleColors: Record<string, string> = {
  [Roles.manager]: "bg-purple-100 text-purple-700",
  [Roles.waiter]: "bg-blue-100 text-blue-700",
  [Roles.kitchen]: "bg-orange-100 text-orange-700",
  [Roles.cashier]: "bg-accent-light text-accent",
  [Roles.owner]: "bg-primary-light text-primary",
  [Roles.admin]: "bg-red-100 text-red-700",
};

const Profile = () => {
  const { handleUpdateImage, avatar, currentUser } = useUpdateProfilImage();
  const role = currentUser?.roles?.find((r) => r !== Roles.user);
  const badgeColor = role ? (roleColors[role] ?? "bg-muted text-muted-foreground") : "bg-muted text-muted-foreground";

  return (
    <DashLayout>
      <div className="space-y-6">
        <PageTitle title="Profil" description="Consultez et modifiez vos informations personnelles" />

        <div className="max-w-3xl mx-auto space-y-6">
          {/* Profile header card */}
          <div className="bg-card rounded-lg border border-border p-6">
            <div className="flex flex-col items-center">
              <EditableAvatar
                imageUrl={currentUser?.image?.url}
                alt="user avatar"
                id="avatar"
                avatar={avatar}
                onChange={handleUpdateImage}
                size={100}
              />
              <div className="text-center">
                <h3 className="font-semibold text-xl text-card-foreground">
                  {currentUser?.fullName}
                </h3>
                {currentUser?.roles && (
                  <span className={`inline-block mt-2 text-xs font-medium px-3 py-1 rounded-full ${badgeColor}`}>
                    {formatRoles(currentUser.roles)}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Personal info card */}
          <div className="bg-card rounded-lg border border-border p-6">
            <InfoUser currentUser={currentUser} />
          </div>
        </div>
      </div>
    </DashLayout>
  );
};

export default Profile;
